import axios from 'axios';
import i18next from 'i18next';
import Notify from '../../utils/useNotify';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import RatingStars from '../../utils/RatingStars';
import { Dialog, DialogBackdrop, DialogPanel, Radio, RadioGroup } from '@headlessui/react';
import { ArrowPathIcon, MinusIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useRefresh } from '../../utils/RefreshProvider';
import ColorSelector from '../product_details/components/ColorSelector';
import { fileNotFound } from '../../assets/images/icons';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Quickview({ slugProduct }) {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const sessionID = localStorage.getItem('session_id');
  const { triggerRefresh } = useRefresh();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;

  const [open, setOpen] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState([]);
  const [reviews, setReviews] = useState(0);
  const [productImage, setProductImage] = useState("");
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [colors, setColors] = useState([]);
  const [selectedColorId, setSelectedColorId] = useState(null);
  const [stockData, setStockData] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);

  const fetchView = async () => {
    setOpen(true);
    try {
      const resProds = await axios.get(localhost + "get-product/" + slugProduct);
      setProduct(resProds.data.product);
      setProductImage(JSON.parse(resProds.data.product.imgs));
      setReviews(resProds.data.reviews);

      const colorsDt = resProds.data.product.colors;
      setColors(colorsDt);
      if(colorsDt.length > 0){
        setSelectedColorId(colorsDt[0].color_id);
      }

      const stockResponse = await axios.get(localhost + `product-stock/${resProds.data.product.id}`);
      setStockData(stockResponse.data);

      if (resProds.data.product.colors.length === 0) {
        const availableSizeIds = stockResponse.data
          .filter(stock => stock.stock > 0 && !stock.color_id)
          .map(stock => stock.size_id);
        setAvailableSizes(availableSizeIds);
      }
    } catch (err) {
      console.error(err);
    }
    try {
      const resSizes = await axios.get(localhost + "all-sizes");
      setSizes(resSizes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedColorId) {
      const availableSizeIds = stockData
        .filter(stock => stock.color_id === selectedColorId && stock.stock > 0)
        .map(stock => stock.size_id);
      setAvailableSizes(availableSizeIds);

      if (selectedSize && !availableSizeIds.includes(selectedSize.id)) {
        setSelectedSize(null);
      }
    }

    console.log(selectedColorId);
  }, [selectedColorId, stockData]);

  const isSizeAvailable = (sizeId) => {
    if (colors.length === 0) {
      return availableSizes.includes(sizeId);
    }
    return selectedColorId ? availableSizes.includes(sizeId) : false;
  };

  const isColorAvailable = (colorId) => {
    return stockData.some(stock => stock.color_id === colorId && stock.stock > 0);
  };

  const handleOrder = async (e) => {
    e.preventDefault();
    if (selectedSize === null) {
      Notify("warning", t("size-warning"));
      return;
    }
    if (colors.length > 0) {
      if (selectedColorId === null) {
        Notify("warning", t("color-warning"));
        return;
      }
    }

    let currentSessionID = sessionID;
    let currentToken = token;

    if (currentSessionID === null && currentToken === null) {
      try {
        const SessionData = await axios.get(localhost + "create-session");
        currentSessionID = SessionData.data.session_id;
        localStorage.setItem('session_id', currentSessionID);
      } catch (err) {
        console.error(err);
        return;
      }
    }
    setBtnLoading(true);

    const stockItem = stockData.find(stock =>
      stock.size_id === selectedSize.id &&
      (colors.length === 0 || stock.color_id === selectedColorId)
    );

    if (!stockItem || stockItem.stock < quantity) {
      Notify("error", t("insufficient-stock"));
      setBtnLoading(false);
      return;
    }

    const data = {
      product_id: product.id,
      size_id: selectedSize.id,
      color_id: selectedColorId,
      quantity: quantity,
      session_id: currentSessionID,
    };

    try {
      await axios.post(localhost + "user/orders", data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      Notify("success", t("add-bag-success"));
      triggerRefresh();
      setOpen(false);
    } catch (err) {
      console.error(err);
      localStorage.removeItem("session_id");
      Notify("error", t("add-bag-error"));
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className='flex flex-col gap-2'>
        <a href={`/product/${slugProduct}`} className="px-4 py-2 text-sm max-sm:px-2 max-sm:py-1.5 max-sm:text-xs rounded-md md:rounded-lg text-center relative text-black bg-white hover:bg-white/80 transition-all duration-300">{t("view")}</a>
        <button onClick={fetchView} className="px-4 py-2 text-sm max-sm:px-2 max-sm:py-1.5 max-sm:text-xs rounded-md md:rounded-lg text-center relative text-white bg-black hover:bg-black/80 transition-all duration-300">{t("quick-view")}</button>
      </div>

      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop transition className="fixed inset-0 hidden bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:block" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full max-sm:min-h-dvh items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
            <DialogPanel transition className="flex w-full transform text-left text-base transition data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:my-8 md:max-w-2xl md:px-4 data-[closed]:md:translate-y-0 data-[closed]:md:scale-95 lg:max-w-4xl">
              <div className="relative flex w-full items-center overflow-hidden bg-white px-4 pb-8 pt-14 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                <button type="button" onClick={() => setOpen(false)} className="absolute right-4 top-4 text-gray-400 hover:text-gray-500 sm:right-6 sm:top-8 md:right-6 md:top-6 lg:right-8 lg:top-8">
                  <span className="sr-only">Close</span>
                  <XMarkIcon aria-hidden="true" className="size-6" />
                </button>
                {loading ? (
                  <div className="min-h-[500px] w-full flex items-center justify-center">
                    <div className="loading-spinner" />
                  </div>
                ) : (
                  <div className="grid w-full grid-cols-1 items-start gap-x-6 gap-y-8 sm:grid-cols-12 lg:gap-x-8">
                    <img loading="lazy" alt={product.slug} src={productImage?localimg + productImage[0]:fileNotFound} className="sm:h-full max-sm:w-full max-sm:h-auto rounded-lg bg-gray-100 object-cover sm:col-span-6" />
                    <div className="sm:col-span-6">
                      <h2 className="text-2xl font-bold text-black sm:pr-12 leading-none">{product.name[i18next.language]}</h2>
                      <section aria-labelledby="information-heading" className="mt-4">
                        <h3 id="information-heading" className="sr-only">Product information</h3>
                        <div className="flex items-end">
                          <p className="text-2xl leading-none">{product.price}</p>
                          <span className='ml-0.5 text-xs leading-none pb-0.5'>MAD</span>
                        </div>
                        <div className="mt-2">
                          <h4 className="sr-only">Reviews</h4>
                          <div className="flex items-center">
                            {<RatingStars rating={product.rating} size="16px" />}
                            <p className="ml-3 text-sm font-medium text-orange-600 hover:text-orange-500">
                              {reviews} {t("reviews")}
                            </p>
                          </div>
                        </div>
                      </section>
                      <section aria-labelledby="options-heading" className="mt-8">
                        <h3 id="options-heading" className="sr-only">Product options</h3>
                        <form onSubmit={handleOrder}>
                          <fieldset>
                            <legend className="text-sm font-medium text-black">{t("quantity")}</legend>
                            <div className="mt-4 flex items-center gap-2">
                              <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))} className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">
                                <span className="sr-only">Decrease quantity</span>
                                <MinusIcon className='size-4' />
                              </button>
                              <input type="number" value={quantity} onChange={(e) => setQuantity(Math.max(1, Math.min(99, Number(e.target.value))))} min="1" max="99"
                                className="h-8 w-16 rounded-md border border-gray-300 text-center text-black focus:outline-none focus:ring-2 focus:ring-orange-500" />
                              <button type="button" onClick={() => setQuantity(Math.min(99, quantity + 1))} className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-50">
                                <span className="sr-only">Increase quantity</span>
                                <PlusIcon className='size-4' />
                              </button>
                            </div>
                          </fieldset>
                          <div className='my-8'>
                            {colors.length > 0 && (
                              <div className='mt-8'>
                                <ColorSelector
                                  colors={colors.map(color => ({
                                    ...color,
                                    disabled: !isColorAvailable(color.color_id)
                                  }))}
                                  t={t}
                                  selectedColorId={selectedColorId}
                                  setSelectedColorId={setSelectedColorId}
                                />
                              </div>
                            )}
                          </div>
                          <fieldset aria-label="Choose a size" className="mt-8">
                            <div className="flex items-center justify-between">
                              <div className="text-sm font-medium text-black">{t("size")}</div>
                              <div />
                            </div>
                            <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-4 grid grid-cols-4 gap-4">
                              {sizes.map((prodSize, index) => {
                                const isAvailable = isSizeAvailable(prodSize.id);

                                return (
                                  <Radio key={index} value={prodSize} disabled={!isAvailable} className={classNames(
                                    isAvailable
                                      ? 'cursor-pointer bg-white text-black shadow-sm'
                                      : 'cursor-not-allowed bg-gray-50 text-gray-200',
                                    'group relative flex items-center justify-center rounded-md border px-4 py-3 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none data-[focus]:ring-2 data-[focus]:ring-orange-500 sm:flex-1',
                                  )}>
                                    <span>{prodSize.name}</span>
                                    {isAvailable ? (
                                      <span aria-hidden="true" className="pointer-events-none absolute -inset-px rounded-md border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-orange-500" />
                                    ) : (
                                      <span aria-hidden="true" className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200">
                                        <svg stroke="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 size-full stroke-2 text-gray-200">
                                          <line x1={0} x2={100} y1={100} y2={0} vectorEffect="non-scaling-stroke" />
                                        </svg>
                                      </span>
                                    )}
                                  </Radio>
                                );
                              })}
                            </RadioGroup>
                          </fieldset>
                          <button type="submit" className={`mt-6 flex w-full items-center justify-center rounded-md border border-transparent px-8 py-3 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 
                            ${btnLoading ? 'bg-orange-400 cursor-not-allowed' : 'bg-orange-600 hover:bg-orange-700'}`} disabled={btnLoading}>
                            {btnLoading ? (
                              <span className="flex justify-center items-center">
                                <ArrowPathIcon className="animate-spin text-white size-6 mr-2" />
                                {t("loading")}
                              </span>
                            ) : (
                              t("add-bag")
                            )}
                          </button>
                          <button onClick={() => setOpen(false)} type="button" className="border border-gray-300 text-black hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 mt-2 flex w-full items-center justify-center rounded-md px-8 py-3 text-base font-medium">
                            {t("cancel")}
                          </button>
                        </form>
                      </section>
                    </div>
                  </div>
                )}
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}